"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parse;

var _prepareSeparatorRegExp = _interopRequireDefault(require("./prepareSeparatorRegExp"));

var notNumberPattern = new RegExp('[^0-9,.-]', 'g');

function parse(value, separators) {
  var dotCount = 0;
  notNumberPattern.lastIndex = 0;
  return String(value).replace((0, _prepareSeparatorRegExp["default"])(separators), '.').replace(/[.]/g, function (dot) {
    dotCount += 1; // leave only first dot

    return dotCount === 1 ? dot : '';
  }) // remove all sign char after first
  .replace(/[-]/g, function (sign, offset) {
    return offset === 0 ? sign : '';
  }).replace(notNumberPattern, '');
}